document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion details").forEach((detail) => {
    const summary = detail.querySelector("summary");
    const icon = summary.querySelector(".accordion-toggle-icon");

    // 初期状態のセット
    if (detail.open) {
      icon.textContent = "−";
    }

    summary.addEventListener("click", function () {
      // 少し待つことで開閉状態の更新を反映
      setTimeout(() => {
        icon.textContent = detail.open ? "−" : "+";
      }, 50);
    });
  });
});
